import React,{useState} from 'react';
import {connect} from "react-redux";
import {clearCredentials} from "../../../slices/userSlice";
import {Link, NavLink} from "react-router-dom";

function Header(props){

    const [isBurgerMenuToggled,setIsBurgerMenuToggled] = useState(false);

    function onBurgerMenuClick(){
        if(isBurgerMenuToggled) {
            setIsBurgerMenuToggled(false);
            if(document.body.classList.contains("noscroll")) {
                document.body.classList.remove("noscroll");
            }
        } else {
            setIsBurgerMenuToggled(true);
            if(!document.body.classList.contains("noscroll")) {
                document.body.classList.add("noscroll");
            }
        }
    }

    function clearBodyNoScrollOnNavLinkClick(event) {
        if(document.body.classList.contains("noscroll")){
            document.body.classList.remove("noscroll");
        }
    }

    function onSignOutClick(){
        props.clearCredentials();
        window.location.pathname = "/";
    }

    function goToTop(){
        window.scrollTo(0,0);
    }

    const activePageCss = {
        desktop: {
            color: '#79E3D7'
        },
        mobile: {
            color: '#AAEDE5'
        }
    };

    return(<header className="header">
        <div className="container">
            <div className="header__desktop">
                <div className="header__desktop__logo">
                    {props.isUserLoggedIn ?
                        (<a style={{width: "125px", transform: "translateY(2px)"}} href="/surveys" onClick={goToTop} ><img src="/assets/img/logo-quisito-white.svg" alt="Bubbly"/></a>)
                        :
                        (<a style={{width: "125px", transform: "translateY(2px)"}} href="/"><img src="/assets/img/logo-quisito-white.svg" alt="Bubbly"/></a>)
                    }
                </div>
                <nav className="header__desktop__nav">
                    <ul className="header__desktop__nav__list" onClick={goToTop}>
                        {/*<li className="header__desktop__nav__list__item">*/}
                        {/*<a className="header__desktop__nav__list__item__link header__desktop__nav__list__item__link--caret"*/}
                        {/*href="javascript:void(0)">Features</a>*/}
                        {/*<ul className="header__desktop__nav__list__item__dropdown">*/}
                        {/*<li className="header__desktop__nav__list__item__dropdown__item">*/}
                        {/*<Link to="/surveys">Surveys</Link>*/}
                        {/*</li>*/}
                        {/*<li className="header__desktop__nav__list__item__dropdown__item"><a*/}
                        {/*href="javascript:void(0)">Integrations</a></li>*/}
                        {/*</ul>*/}
                        {/*</li>*/}
                        {/*<li className="header__desktop__nav__list__item">*/}
                        {/*<a className="header__desktop__nav__list__item__link header__desktop__nav__list__item__link--caret"*/}
                        {/*href="javascript:void(0)">Resources</a>*/}
                        {/*<ul className="header__desktop__nav__list__item__dropdown">*/}
                        {/*<li className="header__desktop__nav__list__item__dropdown__item">*/}
                        {/*<Link to="/survey-templates">Templates</Link>*/}
                        {/*</li>*/}
                        {/*<li className="header__desktop__nav__list__item__dropdown__item"><a href="javascript:void(0)">Blog</a>*/}
                        {/*</li>*/}
                        {/*<li className="header__desktop__nav__list__item__dropdown__item"><a href="javascript:void(0)">Survey*/}
                        {/*Guide</a></li>*/}
                        {/*<li className="header__desktop__nav__list__item__dropdown__item">*/}
                        {/*<Link to="/help-center">Help</Link>*/}
                        {/*</li>*/}
                        {/*<li className="header__desktop__nav__list__item__dropdown__item"><a href="javascript:void(0)">What's*/}
                        {/*new</a></li>*/}
                        {/*</ul>*/}
                        {/*</li>*/}
                        <li className="header__desktop__nav__list__item">
                            <NavLink to="/survey-templates" activeStyle={activePageCss.desktop}>Survey Templates</NavLink>
                        </li>
                        <li className="header__desktop__nav__list__item">
                            <NavLink to="/help-center" activeStyle={activePageCss.desktop}>Help Center</NavLink>
                        </li>
                        <li className="header__desktop__nav__list__item">
                            <NavLink to="/pricing" activeStyle={activePageCss.desktop}>Pricing</NavLink>
                        </li>
                    </ul>
                </nav>
                <nav className="header__desktop__nav header__desktop__nav--right">
                    {props.isUserLoggedIn ?
                        (
                            <ul className="header__desktop__nav__list" onClick={goToTop}>
                                <li className="header__desktop__nav__list__item">
                                    <NavLink to="/surveys" activeStyle={activePageCss.desktop}>My surveys</NavLink>
                                </li>
                                <li className="header__desktop__nav__list__item">
                                    <NavLink to="/my-account" activeStyle={activePageCss.desktop}>My account</NavLink>
                                </li>
                                <li className="header__desktop__nav__list__item">
                                    <a href="#" onClick={(event) => {event.preventDefault();onSignOutClick();}}>Sign out</a>
                                </li>
                            </ul>
                        )
                        :
                        (
                            <ul className="header__desktop__nav__list" onClick={goToTop}>
                                <li className="header__desktop__nav__list__item">
                                    <NavLink to="/register" activeStyle={activePageCss.desktop}>Sign up for free</NavLink>
                                </li>
                                <li className="header__desktop__nav__list__item">
                                    <NavLink to="/login" activeStyle={activePageCss.desktop}>Login</NavLink>
                                </li>
                            </ul>
                        )
                    }
                </nav>
            </div>

            <div className="header__mobile">
                <div className="header__mobile__logo">
                    {props.isUserLoggedIn ?
                        (<Link to="/surveys" onClick={goToTop}><img src="/assets/img/logo-simple-dark.png" alt="Bubbly"/></Link>)
                        :
                        (<a href="/"><img src="/assets/img/logo-simple-dark.png" alt="Bubbly"/></a>)
                    }
                </div>

                <div className={!isBurgerMenuToggled ? "header__mobile__burger-menu" : "header__mobile__burger-menu header__mobile__burger-menu--open"}
                     onClick={onBurgerMenuClick}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <nav className={!isBurgerMenuToggled ? "header__mobile__nav" : "header__mobile__nav header__mobile__nav--open"}>
                    <ul className="header__mobile__nav__list" onClick={goToTop}>
                        <li className="header__mobile__nav__list__item">
                            <NavLink to="/survey-templates" activeStyle={activePageCss.mobile} onClick={clearBodyNoScrollOnNavLinkClick}>Survey Templates</NavLink>
                        </li>
                        <li className="header__mobile__nav__list__item">
                            <NavLink to="/help-center" activeStyle={activePageCss.mobile} onClick={clearBodyNoScrollOnNavLinkClick}>Help Center</NavLink>
                        </li>
                        <li className="header__mobile__nav__list__item">
                            <NavLink to="/pricing" activeStyle={activePageCss.mobile} onClick={clearBodyNoScrollOnNavLinkClick}>Pricing</NavLink>
                        </li>
                        {props.isUserLoggedIn ?
                            (<React.Fragment>
                                <li className="header__mobile__nav__list__item">
                                    <NavLink to="/surveys" activeStyle={activePageCss.mobile} onClick={clearBodyNoScrollOnNavLinkClick}>My surveys</NavLink>
                                </li>
                                <li className="header__mobile__nav__list__item">
                                    <NavLink to="/my-account" activeStyle={activePageCss.mobile} onClick={clearBodyNoScrollOnNavLinkClick}>My account</NavLink>
                                </li>
                                <li className="header__mobile__nav__list__item" onClick={onSignOutClick}>
                                    <a href="#" onClick={(event) => {
                                        event.preventDefault();
                                        clearBodyNoScrollOnNavLinkClick();
                                        onSignOutClick();}}
                                    >Sign out</a>
                                </li>
                            </React.Fragment>)
                            :
                            (<React.Fragment>
                                <li className="header__mobile__nav__list__item">
                                    <NavLink to="/register" activeStyle={activePageCss.mobile} onClick={clearBodyNoScrollOnNavLinkClick}>Sign up for free</NavLink>
                                </li>
                                <li className="header__mobile__nav__list__item">
                                    <NavLink to="/login" activeStyle={activePageCss.mobile} onClick={clearBodyNoScrollOnNavLinkClick}>Login</NavLink>
                                </li>
                            </React.Fragment>)
                        }
                    </ul>
                </nav>
            </div>

        </div>
    </header>)
}

function mapStateToProps(state) {
    return {
        isUserLoggedIn: state.user.loggedIn
    };
}

const mapDispatchToProps = { clearCredentials };

export default connect(mapStateToProps, mapDispatchToProps)(Header);